<template>
  <v-dialog v-model="value" persistent scrollable max-width="655px">
    <v-card class="pa-0">
      <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
        <v-spacer></v-spacer>
        <span class="mdlHeadForms">{{ sTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn  color="btncolor-dark" @click="CloseDialog()" icon small dark outlined>
          <v-icon size="15px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="max-height: 80vh;" class="pa-1">
        <v-container fluid>
            <masivo :bMostrarSeccion="true" sProceso="Festivos"/>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="mx-auto">
          <v-btn color="btncolor" dark class="mx-1" @click="CloseDialog">{{$store.state.jsIdioma.oEquivalencias.btnCancelar}}</v-btn>
          <v-btn color="btncolor" dark class="mx-1" @click="Salvar" :loading="cargandoInfo" :class="{'btn-disabled' : cargandoInfo}" >{{$store.state.jsIdioma.oEquivalencias.btnGuardar}}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Masivo from '@/views/Import.vue'
export default {
  name:'FormAgregarMasivoFestivo',
  components: {
    Masivo
  },
  props:{
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      sTitle: 'Cargar Información',
      aDocumento : [],
      oDataItem:{
        Tipocampo:"FormSelect",
        Valor:'',
        Titulo:'Proceso a importar',
        Inner:'Clientes,',
        Campo:'Area_Empresa',
        CampoFiltro:'',
        Obligatorio: true,
        items:[]
      },
      oDataTabla:{
        // riesgo , grupoimpacto
        headers: [
          { text: 'Prioridad', value: 'prioridad', sortable: false},
          { text: 'Tiempo (Días)', value: 'tiempo', sortable: false },
        ],
        desserts: [
          // { riesgo: 'Hurto', grupoimpacto: 'Personas', Borrable : trrue},
        ]
      },
      oAsociarRiesgos: {},    // Objeto empleado para almacenar la info del la seccion Asociar Riesgoas antes de Agregar
      bAgregarRiesgo: true, 
      formselect:[],
      aDataForm:[],
      cargandoInfo : false      // Esta de carga de información 
    }
  },
  mounted() {
  },
  methods: {
    onAnexos(files){
      this.aDocumento = files[0]
    },
    CloseDialog(){
      this.$emit('input', false)
    },
    Salvar (){
    this.cargandoInfo = true
      this.$emit('guardado')
      this.CloseDialog()
    }
  },
  computed: {
  },
  watch:{
  }

}
</script>
<style lang="scss" scoped>
.mdlHeadForms{
  font-size: 0.9em;
}
</style>
